module.exports = __webpack_public_path__ + "static/textarea-helptext-do-ee2d200d00227337cb7cd61594ab9c19.png";